export enum AssetSubType {
  ArtworkPosterVertical = "ArtworkPosterVertical",
  ArtworkPosterHorizontal = "ArtworkPosterHorizontal",
  ArtworkSeriePosterVertical = "ArtworkSeriePosterVertical",
  ArtworkSeriePosterHorizontal = "ArtworkSeriePosterHorizontal",
  ArtworkSeriePosterSquare = "ArtworkSeriePosterSquare",
  ArtworkSeriePoster169 = "ArtworkSeriePoster169",
  ArtworkSeasonPosterVertical = "ArtworkSeasonPosterVertical",
  ArtworkSeasonPosterHorizontal = "ArtworkSeasonPosterHorizontal",
  ArtworkSeasonPosterSquare = "ArtworkSeasonPosterSquare",
  ArtworkSeasonPoster169 = "ArtworkSeasonPoster169",
  ArtworkSquare = "ArtworkSquare",
  ArtworkPoster169 = "ArtworkPoster169",
  ArtworkPosterHero = "ArtworkPosterHero",
  ArtworkPoster23 = "ArtworkPoster23",
  AudioMusicAndEffects = "AudioMusicAndEffects",
  Partial = "Partial",
  PartialSdh = "PartialSdh",
  FullWithoutPartial = "FullWithoutPartial",
  FullWithoutPartialSdh = "FullWithoutPartialSdh",
  Full = "Full",
  FullSdh = "FullSdh",
}
